const StaffingRoutes = [
    {
        path: '/staffing/employee',
        name: 'Employee',
        component: () => import('@/views/Staffing/EmployeeView.vue'),
    },
    {
        path: '/staffing/addemployee',
        name: 'AddEmployee',
        component: () => import('@/views/Staffing/AddEmployeeView.vue'),
    },
    {
        path: '/staffing/employeetransaction',
        name: 'Employee Transaction',
        component: () => import('@/views/Staffing/EmployeeTransaction/EmployeeTransactionView.vue'),
    },
    {
        path: '/staffing/employeeresignation',
        name: 'EmployeeResignation',
        component: () => import('@/views/Staffing/EmployeeResignationView.vue'),
    },
    {
        path: '/staffing/department',
        name: 'Department',
        component: () => import('@/views/Staffing/DepartmentView.vue'),
    },
    {
        path: '/staffing/position',
        name: 'Position',
        component: () => import('@/views/Staffing/PositionView.vue'),
    },
    {
        path: '/staffing/employeeprofile/:id',
        name: 'EmployeeProfile',
        component: () => import('@/views/Staffing/EmployeeProfile/EmployeeProfileView.vue'),
        props: true,
    },
    {
        path: '/staffing/warning',
        name: 'EmployeeWarning',
        component: () => import('@/views/Staffing/EmployeeWarningView.vue'),
    },
    {
        path: '/staffing/suggestion-comment',
        name: 'StaffingSuggestion',
        component: () => import('@/views/Staffing/suggestion/StaffingSuggestionView.vue'),
    },
    {
        path: '/staffing/data-setup',
        name: 'DataSetup',
        component: () => import('@/views/Staffing/DataSetup/DataSetupView.vue'),
    },
    {
        path: '/staffing/card-templates',
        name: 'CardTemplateList',
        component: () => import('@/views/Staffing/CardTemplate/CardTemplateList.vue'),
    },
    {
        path: '/staffing/card-template/:id/design',
        name: 'CardTemplateDesigner',
        component: () => import('@/views/Staffing/CardTemplate/CardTemplateDesigner.vue'),
        props: true
    },
    {
        path: '/staffing/suggestion-setup',
        name: 'SuggestionSetup',
        component: () => import('@/views/Staffing/suggestion/admin/SuggestionSetupView.vue'),
    },
    // {
    //     path: '/staffing/competency-assessment-admin',
    //     name: 'CompetencyAssessmentAdmin',
    //     component: () => import('@/views/Staffing/CompetencyAssessment/CompetencyAssessmentAdminView.vue'),
    // }
]

export default StaffingRoutes
